<template>
  <div class="filter-chip">
    <span class="filters-names">
      <md-icon class="chip-icon" v-if="chipIcon">{{ chipIcon }}</md-icon>
      {{ chipName }}
    </span>
    <SButtonMaterial
      class="cancel-filter-button"
      :md-ripple="false"
      buttonType="button"
      textColor="white"
      iconColor="dark"
      iconWithoutText="cancel"
      materialClass="dense"
      @button="$emit('removeChip')"
      :data-cy="`remove-filter-chip-btn-${chipId}`"
    />
  </div>
</template>

<script>
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
export default {
  name: "SFilterChip",
  props: ["chipName", "chipIcon", "chipId"],
  components: {
    SButtonMaterial,
  },
};
</script>

<style lang="scss" scoped>
.filters-names {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.25px;
  color: rgba(0, 0, 0, 0.87);
}
.filter-chip {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px 8px;
  gap: 8px;
  height: 32px;
  flex: none;
  flex-grow: 0;
  background: rgba(5, 145, 155, 0.2);
  border-radius: 16px;
}
.cancel-filter-button {
  min-width: 20px;
  margin: unset;
  width: 20px;
  height: 20px;
}
.icon-without-text {
  font-size: 22px !important;
}
.chip-icon {
  color: $black !important;
}
</style>
